import './header.component.scss'
import './navigation.scss'
import './header.component.pug'
import { throttle } from '../../application/utils/timings'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const header = document.querySelector('.header')
const headerToggle = document.querySelector('.header-menu-trigger')
const navigation = document.querySelector('.navigation')
const miniCart = document.querySelector('.mini-cart')

function headerScrollHandler() {
  const preHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-pre-height'
    )
  )
  if (window.scrollY >= preHeight) {
    header.classList.add('in-scroll')
  } else {
    header.classList.remove('in-scroll')
    header.style.transform = `translateY(${window.scrollY * -1}px)`
  }
}

function headerHeightTransport() {
  document.documentElement.style.setProperty(
    '--header-height',
    `${header.getBoundingClientRect().height}px`
  )
  // document.documentElement.style.setProperty(
  //   '--header-pre-height',
  //   `${headerPre.getBoundingClientRect().height}px`
  // )
}

if (header) {
  window.addEventListener('scroll', headerScrollHandler)
  window.addEventListener('resize', throttle(headerHeightTransport, 200))
  headerHeightTransport()
  headerScrollHandler()
}

if (headerToggle) {
  headerToggle.addEventListener('click', function () {
    document.body.classList.toggle('mobile-nav-open')

    if (document.body.classList.contains('mobile-nav-open')) {
      disableBodyScroll(navigation)
      miniCart.classList.remove('open')
    } else {
      enableBodyScroll(navigation)
    }
  })
}
